import { render, staticRenderFns } from "./UploadDevelopmentDocument.vue?vue&type=template&id=ab4a432a&"
import script from "./UploadDevelopmentDocument.ts?vue&type=script&lang=ts&"
export * from "./UploadDevelopmentDocument.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports